import React from 'react';
import { FaUserEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../constants";

const ProfileAlert = () => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center -mt-4 mb-8 animate-bounce">
      <button 
        onClick={() => navigate(ROUTES.editProfile)}
        className="flex items-center gap-3 px-6 py-3 bg-blue-600 text-white rounded-full shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all hover:scale-105"
      >
        <FaUserEdit size={18} />
        <span className="text-sm font-semibold">Complete your profile to get started!</span>
      </button>
    </div>
  );
};

export default ProfileAlert;